import React from "react";
import { submitCaptcha } from "../Utils/captcha";
import config from "../config";

const base_url = config?.base_url;

/*
  Localhost and preprod only. Mirrors the devEnv check in Components/Header.
*/
const DEV_HOST =
  typeof window !== "undefined" &&
  (window.location?.host?.includes("localhost") ||
    window.location?.host?.includes("127.0.0") ||
    window.location?.host?.includes("preprod"));

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, componentStack: null };
  }

  static getDerivedStateFromError(error) {
    // Actualiza el estado para que el siguiente renderizado muestre la interfaz de repuesto
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    /*
      Keep the component stack so the panel below can name the component that
      threw. Only ever shown on localhost and preprod -- see the render.
    */
    this.setState({ componentStack: errorInfo?.componentStack });
    // También puedes registrar el error en un servicio de reporte de errores
    submitCaptcha().then((token) => {
      fetch(base_url + "error/handle", {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-type": "application/x-www-form-urlencoded",
          credentials: "include",
        },
        credentials: "include",
        body: `token=${token}&location=${window?.location?.href}&error=${error})}&errorInfo=${error?.stack})}`,
      });
    });
  }

  render() {
    if (this.state.hasError) {
      // Puedes renderizar cualquier interfaz de repuesto
      return (
        <div
          style={{
            position: "fixed",
            right: "0",
            top: "0",
            left: "0",
            bottom: "0",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            margin: "0 auto",
            width: "100vw",
            height: "100vh",
          }}
        >
          <div
            style={{
              maxWidth: "510px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              wordBreak: "break-word",
            }}
          >
            <h1
              style={{
                margin: "0",
              }}
            >
              {localStorage.getItem("language") === "en"
                ? "Something went wrong."
                : "Quelque chose s'est mal passé."}
            </h1>
            <h2
              style={{
                margin: "0",
                width: "",
              }}
            >
              {localStorage.getItem("language") === "en"
                ? "The engineering team is already solving the problem !"
                : "L'équipe d'ingénieurs est déjà en train de résoudre le problème !"}
            </h2>
            <button
              style={{
                alignSelf: "center",
                width: "90px",
                textAlign: "center",
                height: "40px",
                backgroundColor: "rgba(0, 145, 234, 1)",
                border: "none",
                borderRadius: "8px",
                color: "white",
                marginTop: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                // eslint-disable-next-line no-restricted-globals
                location.reload();
              }}
            >
              {localStorage.getItem("language") === "en"
                ? "Go Back"
                : "Retourner"}
            </button>
            {/*
              On a developer machine the message above is a dead end: the real
              error only exists in the console, and the boundary has already
              swallowed it. Showing it here turns "something went wrong" into
              something actionable. Gated on host, so a real user never sees a
              stack trace -- the same devEnv test the header uses.
            */}
            {DEV_HOST && (
              <pre
                style={{
                  maxHeight: "40vh",
                  overflow: "auto",
                  background: "#f4f4f5",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "12px",
                  fontSize: "12px",
                  lineHeight: "1.45",
                  whiteSpace: "pre-wrap",
                  textAlign: "left",
                }}
              >
                {String(this.state.error?.stack || this.state.error || "")}
                {this.state.componentStack || ""}
              </pre>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
